import React, { useState, useEffect, useCallback } from 'react';
import { api } from './api.js';
import { Wave } from './componentes/Comunes.jsx';
import { Home } from './componentes/Home.jsx';
import { SedeDetail } from './componentes/SedeDetail.jsx';
import { Booking } from './componentes/Booking.jsx';
import { Identify } from './componentes/Identify.jsx';
import { Confirm } from './componentes/Confirm.jsx';
import { VerPase } from './componentes/VerPase.jsx';
import { isoOffset } from './utiles/fechas.js';

// El enlace permanente del pase es la única ruta con URL propia. No hace
// falta un enrutador entero para una ruta: se lee del path al arrancar.
function tokenDeLaUrl() {
  const m = /^\/pase\/([a-f0-9]{32,})$/i.exec(window.location.pathname);
  return m ? m[1] : null;
}

export default function App() {
  const [tokenPase, setTokenPase] = useState(tokenDeLaUrl);
  const [view, setView] = useState('home');
  const [sedeId, setSedeId] = useState(null);
  const [date, setDate] = useState(isoOffset(0));
  const [time, setTime] = useState(null);
  const [reserva, setReserva] = useState(null);

  // El escaparate se pide una vez y se reutiliza en todas las pantallas: son
  // los mismos datos y no cambian mientras dura una reserva.
  const [sedes, setSedes] = useState({ datos: null, cargando: true, error: null });

  const cargarSedes = useCallback(() => {
    setSedes({ datos: null, cargando: true, error: null });
    api.sedes()
      .then((datos) => setSedes({ datos, cargando: false, error: null }))
      .catch((error) => setSedes({ datos: null, cargando: false, error }));
  }, []);

  useEffect(cargarSedes, [cargarSedes]);

  const sede = sedeId && sedes.datos ? sedes.datos.find((s) => s.id === sedeId) : null;

  const go = (v, id) => {
    setView(v);
    if (id !== undefined) setSedeId(id);
    if (v === 'home') {
      if (tokenPase) {
        // Salir del pase devuelve la URL a la raíz, para que un refresco no
        // vuelva a abrirlo.
        window.history.replaceState({}, '', '/');
        setTokenPase(null);
      }
      setSedeId(null);
      setTime(null);
      setReserva(null);
      setDate(isoOffset(0));
      cargarSedes();   // al volver, la disponibilidad puede haber cambiado
    }
    window.scrollTo(0, 0);
  };

  const atras = () => {
    if (view === 'sede') go('home');
    else if (view === 'book') setView('sede');
    else if (view === 'identify') setView('book');
    else if (view === 'confirm') go('home');
    window.scrollTo(0, 0);
  };

  const pasos = { book: 'Paso 1 de 2 · Horario', identify: 'Paso 2 de 2 · Datos' };

  return (
    <div className="tapp">
      <div className="topbar"><div className="topbar-in">
        {view !== 'home' ? <button className="back" onClick={atras}>‹</button> : null}
        <div className="brand"><div className="wordmark">TUNE</div><Wave /></div>
        <div className="tb-spacer" />
        <div className="tb-step">{pasos[view] || ''}</div>
      </div></div>

      {tokenPase ? <VerPase token={tokenPase} go={go} /> : null}
      {!tokenPase && view === 'home' ? <Home sedes={{ ...sedes, recargar: cargarSedes }} go={go} /> : null}
      {!tokenPase && view === 'sede' && sede ? <SedeDetail sede={sede} go={go} /> : null}
      {!tokenPase && view === 'book' && sede ? (
        <Booking sede={sede} date={date} setDate={setDate}
                 onPick={(t) => { setTime(t); setView('identify'); window.scrollTo(0, 0); }} />
      ) : null}
      {!tokenPase && view === 'identify' && sede ? (
        <Identify sede={sede} date={date} time={time}
                  onBack={() => { setView('book'); window.scrollTo(0, 0); }}
                  onListo={(r) => { setReserva(r); setView('confirm'); window.scrollTo(0, 0); }} />
      ) : null}
      {!tokenPase && view === 'confirm' && sede && reserva ? (
        <Confirm sede={sede} date={date} time={time} reserva={reserva} go={go} />
      ) : null}
    </div>
  );
}
